<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="sysconfiginfo" :rules="rules" ref="sysconfigrule" label-width="120px" class="">
			<el-row>
				<el-col :span="9">
					<el-form-item label="配置名称" prop="name">
						<el-input clearable v-model="sysconfiginfo.name" maxlength="30"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="9">
					<el-form-item label="配置编码" prop="code">
						<el-input clearable v-model="sysconfiginfo.code" :disabled="disabled_cord" maxlength="30"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="18">
					<el-form-item label="配置参数" prop="value">
						<el-input type="textarea" :rows="4" placeholder="请输入配置参数" maxlength="99999" clearable v-model="sysconfiginfo.value"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button plain @click="closeDlg">取消</el-button>
			<el-button type="primary" @click="saveSysConfigs">保存</el-button>
		</div>
	</div>
</template>

<script> 
	import { getSysConfigDetail,addNewSysConfig, editSysConfig } from '/static/apiUrl.js'
	export default {
		name : 'SysConfigDetail',
		data() {
			return {
				editok: false,
				disabled_cord: false,
				uploadheader : {
					Authorization: sessionStorage.getItem("authToken")
				},				
				sysconfiginfo : {
					"id": "",
					"name": "",
					"code": "",
					"value": "",
				},			
				rules:{
					name: [
						{ required: true, message: '请输入配置名称', trigger: 'blur' }
					],
					code: [
						{ required: true, message: '请输入配置编码', trigger: 'blur' }
					],
				}
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			select_id : {
				type: String,
				required: false
			}
		},
		watch: {
			select_id: {
				immediate: true,
				handler(newVal) {
					console.log(newVal)				
					this.clearData()
					if (newVal != "") {						
						this.disabled_cord = true
					}
					this.sysconfigDetail(newVal)
				}
			},
		},
		methods: {
			clearData(){
				this.sysconfiginfo = {
					"id": "",
					"name": "",
					"code": "",
					"value": "",
				}
				this.editok = false
				this.disabled_cord = false
			},
			closeDlg() {
				this.$emit("needRefrash",false,false)
			},
			sysconfigDetail(id){
				if(id !== undefined && id !== null && id != ''){
					getSysConfigDetail({id : id}).then(res => {
						console.log(res)
						if(0 == res.code){
							this.sysconfiginfo = res.data
						}
					})
				}
			},
			saveSysConfigs(){
				this.$refs["sysconfigrule"].validate((valid) => {
					if (valid) {
						if(this.sysconfiginfo.id != null && this.sysconfiginfo.id != ''){  //编辑
							editSysConfig(this.sysconfiginfo).then(res => {
								console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.$emit("needRefrash",true,false)
									this.$message.success("修改配置信息成功")
								}else{
									this.$emit("needRefrash",false)
									this.$message.error(res.msg,true)
								}
							})
						}else{ //新增
							addNewSysConfig(this.sysconfiginfo).then(res => {
								console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.clearData();
									this.$emit("needRefrash",true,false)
									this.$message.success("添加配置信息成功")
								}else{
									this.$emit("needRefrash",false,true)
									this.$message.error(res.msg)
								}
							})
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>